import { ModuleTypeId } from "../../types/DBTables";
import { UseFormReturn } from "react-hook-form";
import { useGlobalData } from "../GlobalDataProvider";
import CheckboxEditor from "../Global/Editors/CheckboxEditor";
import { DTOModule } from "../../types/building";
import { useParams } from "react-router";
import { Table } from "react-bootstrap";
import { IModuleKylmaskin } from "../../types/ModuleDatas";
import { nameof } from "../Global/Utils";

interface IProps {
  module: DTOModule;
  data: any;
  formHook: UseFormReturn;
}

const ConfigKylmaskin = ({ module, data, formHook }: IProps) => {
  const { buildingId } = useParams();
  const globalData = useGlobalData();

  const building = buildingId ? globalData.buildings?.find((b) => b.id === parseInt(buildingId)) : undefined;
  const moduleData = data as IModuleKylmaskin;

  if (!building) return <></>;

  const modulesKs = building?.modules.filter((m) => m.moduleTypeId === ModuleTypeId.KylaVattenburet);
  //const checkedKsIds = moduleData.betjänadeSystem ? moduleData.betjänadeSystem : [];

  return (
    <>
      <Table className="mt-1">
        <thead>
          <tr>
            <th style={{ width: 40, textAlign: "center" }}>Betjänas</th>
            <th>Köldbärarsystem</th>
          </tr>
        </thead>
        <tbody>
          {modulesKs.map((m) => (
            <tr key={m.id}>
              <td>
                <CheckboxEditor label="" fieldName={"frmData." + m.id} formHook={formHook} />
              </td>
              <td>{m.name}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </>
  );
};

export default ConfigKylmaskin;
